"use client"

/** Shared Analysis intro (idle/retry). Storybook: Catalog → Search → Analysis intro card / Analysis UI. */
import { Card, CardContent, getSmartAnalysisIntroCopy } from '@yeshuman/sdk'
import type { SmartAnalysisDirection, SmartAnalysisIntroMode } from '@yeshuman/sdk'
import type { ReactNode } from 'react'
import { SmartAnalysisInstructionsField } from './smart-analysis-instructions-field'
import { SmartAnalysisRunToolbar } from './smart-analysis-run-toolbar'

export type SmartAnalysisIntroCardProps = {
  direction: SmartAnalysisDirection
  mode: SmartAnalysisIntroMode
  jobTitle?: string
  jobScoped?: boolean
  emptyActiveApplicants?: boolean
  instructions: string
  onInstructionsChange: (value: string) => void
  instructionsFieldId?: string
  preferencesLeadingSlot?: ReactNode
  onRun: () => void
  isRunning: boolean
  runDisabled?: boolean
  lastUpdatedAt?: string | null
}

export function SmartAnalysisIntroCard({
  direction,
  mode,
  jobTitle,
  jobScoped,
  emptyActiveApplicants,
  instructions,
  onInstructionsChange,
  instructionsFieldId,
  preferencesLeadingSlot,
  onRun,
  isRunning,
  runDisabled = false,
  lastUpdatedAt,
}: SmartAnalysisIntroCardProps) {
  const copy = getSmartAnalysisIntroCopy({
    direction,
    mode,
    jobTitle,
    jobScoped,
    emptyActiveApplicants,
  })
  const fieldId = instructionsFieldId ?? `smart-analysis-instructions-${direction}`

  return (
    <Card>
      <CardContent className="space-y-4">
        <div className="space-y-2 text-center sm:text-left">
          <h3 className="text-lg font-semibold">{copy.title}</h3>
          <p className="text-sm text-muted-foreground">{copy.description}</p>
        </div>

        <SmartAnalysisInstructionsField
          id={fieldId}
          direction={direction}
          mode={mode}
          jobTitle={jobTitle}
          jobScoped={jobScoped}
          emptyActiveApplicants={emptyActiveApplicants}
          value={instructions}
          onChange={onInstructionsChange}
          leadingSlot={preferencesLeadingSlot}
        />

        <SmartAnalysisRunToolbar
          onClick={onRun}
          isSearching={isRunning}
          disabled={runDisabled}
          lastUpdatedAt={lastUpdatedAt}
        />
      </CardContent>
    </Card>
  )
}
